module.exports = __webpack_public_path__ + "static/img/mythya.5d8707c4.png";